// Define currency symbol mappings with position
var currencySymbols = {
  "EUR": { symbol: "€", position: "before" },      // Euro
  "DKK": { symbol: " Kr", position: "after" },     // Danish Krone
  "SEK": { symbol: " Kr", position: "after" },     // Swedish Krona
  "NOK": { symbol: " kr", position: "after" },     // Norwegian Krone
  "GBP": { symbol: "£", position: "before" },      // British Pound
  "CHF": { symbol: " CHF", position: "after" },    // Swiss Franc
  "PLN": { symbol: " zł", position: "after" },     // Polish Zloty
  "CZK": { symbol: " Kč", position: "after" },     // Czech Koruna
  "HUF": { symbol: " Ft", position: "after" },     // Hungarian Forint
  "RON": { symbol: " lei", position: "after" },    // Romanian Leu
  "USD": { symbol: "$", position: "before" },      // United States Dollar
  "AUD": { symbol: "A$", position: "before" },     // Australian Dollar
  "CAD": { symbol: "C$", position: "before" },     // Canadian Dollar
  "NZD": { symbol: "NZ$", position: "before" }     // New Zealand Dollar
};

// Function to get the current currency in Shopify
function getCurrency() {
  return Shopify.currency.active || "EUR"; // Default to EUR if currency is not set
}

// Function to format the price based on currency
function formatPrice(price) {
  var currency = getCurrency();
  var symbol = currencySymbols[currency].symbol;
  var position = currencySymbols[currency].position;

  return position === "before"
    ? symbol + price.toFixed(2)
    : price.toFixed(2) + symbol;
}

// This function updates the price and discount
function updatePriceAndDiscount(variant) {
  var selectedVariantPrice = variantPrices[variant];
  if (selectedVariantPrice) {
    var discountRate;
    if (document.querySelector('.promotion-block.special-discount')) {
      discountRate = 0.20;
    } else if (document.querySelector('.promotion-block.standard-discount')) {
      discountRate = 0.15;
    }

    if (discountRate) {
      var discount_value = selectedVariantPrice * discountRate;
      var sales_price = selectedVariantPrice - discount_value;
      var savingsEl = document.querySelector('.savings');
      if (savingsEl) savingsEl.textContent = formatPrice(discount_value);
      var discountedPriceEl = document.querySelector('.discounted-price');
      if (discountedPriceEl) discountedPriceEl.textContent = "Discounted Price: " + formatPrice(sales_price);
      var voucherPriceEl = document.querySelector('[data-voucher-price]');
      var voucherSavingEl = document.querySelector('[data-voucher-saving]');
      if (voucherPriceEl) voucherPriceEl.textContent = formatPrice(sales_price);
      if (voucherSavingEl) voucherSavingEl.textContent = formatPrice(discount_value);
    }
  }
}

// Event listener setup for radio buttons
var radios = document.querySelectorAll('.options-selection__option-value-input');
radios.forEach(function(radio) {
  radio.addEventListener('change', function() {
    var selectedOptions = document.querySelectorAll('.options-selection__option-value-input:checked');
    var variant = Array.from(selectedOptions).map(option => option.value).join(' / ');
    updatePriceAndDiscount(variant);
  });
});

document.addEventListener('variant-change', function(e) {
  if (e.detail && e.detail.variant && e.detail.variant.title) {
    updatePriceAndDiscount(e.detail.variant.title);
  }
}, true);

var voucher = document.querySelector('[data-voucher]');
if (voucher) {
  var voucherCheck = voucher.querySelector('[data-voucher-check]');
  if (voucherCheck) {
    voucherCheck.addEventListener('change', function() {
      if (voucherCheck.checked) {
        var code = voucher.getAttribute('data-voucher-code');
        if (code) {
          fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function() {});
        }
      }
    });
  }
}

// Initial update for the currently selected variant
var currentVariant = Array.from(document.querySelectorAll('.options-selection__option-value-input:checked')).map(option => option.value).join(' / ');
updatePriceAndDiscount(currentVariant);